import React from 'react';
import PropTypes from 'prop-types';
import RouterLink from 'next/link';
import queryString from 'query-string';
import { Box, Link } from '@qga/roo-ui/components';
import { scrollTop } from 'lib/browser';

const PreviousLink = ({ page, currentQuery, pathname, onClick }) => {
  const newQuery = { ...currentQuery, page: page - 1 };
  const showLink = page > 1;
  const linkTo = { pathname, search: queryString.stringify(newQuery) };

  const handleOnClick = () => {
    onClick(newQuery.page);
    scrollTop();
  };

  return (
    <Box>
      {showLink && (
        <RouterLink href={`${linkTo.pathname}?${linkTo.search}`} passHref shallow>
          <Link underline color="greys.charcoal" data-testid="prev-link" px={3} py={1} onClick={handleOnClick}>
            Previous
          </Link>
        </RouterLink>
      )}
    </Box>
  );
};

PreviousLink.propTypes = {
  page: PropTypes.number.isRequired,
  pathname: PropTypes.string.isRequired,
  currentQuery: PropTypes.shape({}).isRequired,
  onClick: PropTypes.func,
};

PreviousLink.defaultProps = {
  onClick: () => {},
};

export default PreviousLink;
